/* Free gift chooser — multi-gift campaigns
   ---------------------------------------------------------------------------
   Companion to free-gift-chooser.css. Deliberately thin: the app already models
   single-select through its claim button classes, so the selected state is CSS
   against those classes rather than state kept here. This file only:

     1. marks an allowlisted campaign's widget with .fg-chooser (which is also
        what reveals it, so the default panel never flashes),
     2. makes the whole row a hit target by forwarding a row click to that row's
        own claim control — the app's real action stays the app's,
     3. lets the shopper choose before the product is in the cart — the app
        refuses to claim until then, so the choice is held and claimed as soon as
        it is allowed,
     4. keeps the hint line in step with which of those states applies.

   Copy for the gift names and the header comes from the campaign settings, so
   nothing here invents text a merchant cannot change. */

(function () {
  if (window.freeGiftChooserLoaded) return;
  window.freeGiftChooserLoaded = true;

  /* CAMPAIGN ALLOWLIST — only these multi-gift campaigns get this treatment.

     Campaigns are named by their own id, never by the number on the widget. That
     number is only the campaign's position in gfg.settings.freeGifts, so deleting
     one in the Globo admin renumbers every campaign after it. Removing the Jimmy
     Broadbent floor mat campaign slid this one from position 4 to 3, this list
     stopped matching anything, and the chooser quietly stopped applying — while
     free-gift-cta.js, whose allowlist did still name 3, dressed it as a
     single-gift offer on the buy button. Ids do not move. */
  var CHOOSER_CAMPAIGN_IDS = [
    "6a9550deab2abafbf29b5067", // Free Sim Floor Mat — the livery chooser
  ];
  var CHOOSER_CLASS = "fg-chooser";
  var HINT_CLASS = "fg-chooser__hint";
  var PICKED_CLASS = "fg-chooser__row--picked";

  /* Copy. The header is normally the app's own ("Available Free gifts", set in
     the campaign settings) — setting it here overrides that field, so this is
     now the place to edit it, not the Globo admin. */
  var HEADER_TEXT = "Choose Your Free Gift";
  var HINT_IDLE = "Select one to add to your order for free";
  var HINT_PICKED_SUFFIX = " — added to your order for free";

  var CLAIM = ".gfgFreeGiftClaimButton";
  var ROW = ".gfgFreeGiftMsgOptionRow";
  var INVALID = "gfgFreeGiftInvalidProductClaimButton";
  var ACTIVE = "gfgFreeGiftActiveFreeGiftClaimButton";

  /* The gift the shopper chose while the app could not yet claim it, held by
     product-id (the attribute the app puts on each row) so it survives the
     re-render that add-to-cart triggers. In memory only: a pick should never
     outlive the page and surprise someone on a later visit. */
  var pendingPick = null;

  /* Announced for sidecart-free-gift.js, which shows a "you have not taken your
     free gift" panel in the cart drawer.

     A gift chosen here is claimed long after the add-to-cart it was waiting on:
     the app has to see the product in the cart before it will allow the claim,
     and then takes seconds more to add the gift — around five in total, all of
     it after the drawer has opened. Nothing observable moves in that time. The
     app's own state flags never change, its claim buttons go back to "ready to
     claim", and the cart sits unchanged, so the panel had no way to tell a
     shopper who has not chosen from one whose choice is still in the post, and
     told both to pick a gift.

     Only this file knows, so it says so, in two parts:

       freeGiftChoiceHeld    a pick is being held for a claim the app will not
                             yet accept. No expiry — every path that lets go of
                             the pick clears it, and it lives only as long as the
                             page the shopper chose on.
       freeGiftClaimInFlight the claim has gone in and the gift is on its way.
                             A timestamp, so a claim that never completes cannot
                             silence the reminder for the rest of the session. */
  function setPendingPick(value) {
    pendingPick = value;
    window.freeGiftChoiceHeld = !!value;
    // Which gift, so the reader can claim it rather than only wait for it.
    window.freeGiftHeldChoice = value || null;
  }

  /* Lets sidecart-free-gift.js take a held pick off our hands and claim it
     itself the moment the cart qualifies, instead of waiting for the app to
     enable its own claim button — which is most of the delay before a chosen
     gift appears. Handing the pick over rather than copying it is what stops
     both of us claiming: JS is single-threaded, so a caller that finds no claim
     in flight and releases in the same breath cannot be raced by this file. */
  window.freeGiftChooserRelease = function () {
    setPendingPick(null);
  };

  function markClaimInFlight() {
    window.freeGiftClaimInFlight = Date.now();
  }

  function chooserWidget() {
    var campaigns = (window.gfg && gfg.settings && gfg.settings.freeGifts) || [];
    for (var i = 0; i < campaigns.length; i++) {
      if (!campaigns[i] || CHOOSER_CAMPAIGN_IDS.indexOf(campaigns[i]._id) === -1) continue;
      var el = document.getElementById("FREEGIFTCAMPAIGN-WIDGET-" + i);
      if (el && el.querySelector(".gfgFreeGiftMsgOptionRow")) return el;
    }
    return null;
  }

  // One delegated listener per widget, so re-rendered rows stay clickable.
  function bindRowClicks(widget) {
    if (widget.freeGiftChooserBound) return;
    widget.freeGiftChooserBound = true;

    widget.addEventListener("click", function (event) {
      /* Only a real gesture counts as choosing. Something on the page dispatches
         a synthetic click through the first row on load, which otherwise picked a
         gift for the shopper — and would then have claimed it for them on
         add-to-cart. Programmatic clicks report isTrusted false. */
      if (!event.isTrusted) return;

      var row = event.target.closest(".gfgFreeGiftMsgOptionRow");
      if (!row) return;

      // Clicks that already landed on the claim control are the app's to handle;
      // forwarding them again would loop — but the claim is still on its way.
      if (event.target.closest(CLAIM)) {
        markClaimInFlight();
        return;
      }

      var claim = row.querySelector(CLAIM);
      if (!claim) return;

      /* Not claimable yet — hold the choice and show it as chosen. Refusing the
         click here is what made the chooser feel broken on the product page. */
      if (claim.classList.contains(INVALID)) {
        setPendingPick(row.getAttribute("product-id"));
        apply();
        return;
      }

      setPendingPick(null);
      markClaimInFlight();
      claim.click();
    });
  }

  function setHeader(widget) {
    var bar = widget.querySelector(".gfgFreeGiftWidgetTitleBar");
    if (!bar) return;
    if (bar.textContent.trim() !== HEADER_TEXT) bar.textContent = HEADER_TEXT;
  }

  function setHint(widget, text) {
    var hint = widget.querySelector("." + HINT_CLASS);
    if (!text) {
      if (hint) hint.remove();
      return;
    }
    if (!hint) {
      hint = document.createElement("span");
      hint.className = HINT_CLASS;
      var list = widget.querySelector(".gfgFreeGiftOptionsContainerDiv");
      if (list && list.parentNode) list.parentNode.appendChild(hint);
      else widget.appendChild(hint);
    }
    if (hint.textContent !== text) hint.textContent = text;
  }

  function giftName(row) {
    var el = row.querySelector(".gfgFreeGiftMsgTitle");
    return el ? (el.textContent || "").trim() : "";
  }

  /* Reconcile the three states the app can be in with the choice the shopper
     has made, and claim a held choice as soon as the app permits it. */
  function syncState(widget) {
    var rows = widget.querySelectorAll(ROW);
    if (!rows.length) return;

    var claimable = false;
    var alreadyClaimed = false;
    var i;
    var claim;

    for (i = 0; i < rows.length; i++) {
      claim = rows[i].querySelector(CLAIM);
      if (!claim) continue;
      if (claim.classList.contains(ACTIVE)) alreadyClaimed = true;
      else if (!claim.classList.contains(INVALID)) claimable = true;
    }

    // The app's own claimed state always wins over a held choice.
    if (alreadyClaimed) {
      setPendingPick(null);
      for (i = 0; i < rows.length; i++) rows[i].classList.remove(PICKED_CLASS);
      setHint(widget, "");
      return;
    }

    if (claimable && pendingPick) {
      for (i = 0; i < rows.length; i++) {
        if (rows[i].getAttribute("product-id") !== pendingPick) continue;
        claim = rows[i].querySelector(CLAIM);
        setPendingPick(null);
        rows[i].classList.remove(PICKED_CLASS);
        if (claim) {
          markClaimInFlight();
          claim.click();
        }
        return;
      }
      setPendingPick(null);
    }

    var pickedName = "";
    for (i = 0; i < rows.length; i++) {
      var isPick = !!pendingPick && rows[i].getAttribute("product-id") === pendingPick;
      rows[i].classList.toggle(PICKED_CLASS, isPick);
      if (isPick) pickedName = giftName(rows[i]);
    }

    if (claimable) setHint(widget, "");
    else if (pickedName) setHint(widget, pickedName + HINT_PICKED_SUFFIX);
    else setHint(widget, HINT_IDLE);
  }

  function apply() {
    var widget = chooserWidget();
    if (!widget) return false;
    widget.classList.add(CHOOSER_CLASS);
    setHeader(widget);
    bindRowClicks(widget);
    syncState(widget);
    return true;
  }

  function start() {
    apply();
    // The widget arrives asynchronously.
    var interval = setInterval(apply, 400);
    setTimeout(function () {
      clearInterval(interval);
    }, 15000);

    /* The app re-renders these rows on add-to-cart and on every claim, which is
       when the claim classes change — re-apply on any DOM change. Observing
       document.body rather than the widget's container, which gets replaced. */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        apply();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
